import { sprintf } from 'sprintf-js';

import translation from '../../config/translation';

export default state => {
	const language = state.root.currentLang;

	const intl = (word, ...params) => {
		let newWord = word;
		if (translation[word] && translation[word][language]) {
			newWord = translation[word][language];
		} else {
			//throw new Error(`Check word in "translation" list. Word: ${word}, language: ${language}`);
		}
		return sprintf(newWord, ...params);
	};

	intl.language = language;

	return intl;
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/intl.js